import { render, staticRenderFns } from "./RepxMessageDetail.vue?vue&type=template&id=3f96cb64"
import script from "./RepxMessageDetail.vue?vue&type=script&lang=js"
export * from "./RepxMessageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports